import styled from 'styled-components';

export const ContainerStyled = styled.div`
    .container{
        position: relative;
    }

    .upload-list p{
        margin: 0;
        &.invalid{
            color: #dc3545;
        }
    }
    .btn-download{
        margin-left: 15px;
        padding: 5px 20px 0px 20px;
    }

    .link-historico{
        position: absolute;
        top: 48px;
        right: 0;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 13px;
        color: #4A90E2;

        .svg-inline--fa{
            font-size: 14px;
        }
    }
    .campo-validade{
        width: calc(50% - 10px);
        float: left;
        margin: 0 5px;
    }
`;